export const GET_QUESTIONS_BY_JOB_ID_ENDPOINT = (jobId: number) => `job/${jobId}/question`;
export const ANSWER_QUESTION_ENDPOINT = 'job/answer';
export const AUTHENTICATE_JOB_SERVICE_ENDPOINT = '/admin/auth';
